const coaches= [
    {
        id: 1,
        title: "TALLER DE ASTROLOGÍA: LOS DARMAS Y KARMAS DE JÚPITER EN TU CARTA NATAL",
        description: "Júpiter es considerado un planeta benéfico mayor y según donde cada quien lo trae de\n" +
            "nacimiento en su carta natal, podrá identificar sus dones y talentos para generar\n" +
            "ingresos, trabajo y determinados talentos.\n" +
            "Si eres alguien que no logra determinar cómo ser próspero y constante, el presente taller\n" +
            "te ayudará mucho a tomar decisiones importantes.\n" +
            "De manera dinámica y precisa, el taller será dictado por la especialista y astróloga\n" +
            "terapeuta profesional, Rosa María Cifuentes.\n",
        themes: [
            "Rol de Júpiter como planeta en tu carta natal",
            "Júpiter como Dharma, formas de volverlo emprendimiento y oficios",
            "Júpiter como asunto Kármico en tu mapa natal",
            "Júpiter retrógrado y su impacto en tu vida profesional y en salud",
            "Tránsito de Júpiter para estudiar y revisar temas de salud",
            "Tránsitos de Júpiter y oficios recomendados",
            "Inversiones y negociaciones según la posición de Júpiter en la carta natal"
        ],
        image: "/assets/images/talleres_1.jpg",
        date: {
            beginning: "2025-11-15T10:00:00",
            end: "2025-11-16T17:00:00"
        },
        hour: "10:00 am - 5:00 pm (break 1:00 pm)",
        mode: ["Presencial", "Zoom"],
        location: {
            name: "Cámara de Comercio de Lima",
            address: "Av Giusseppe Garibaldi 396, Jesús María"
        },
        cost: {
            pen: 700,
            usd: 200,
            money_advance: 350,
            notes: "No se realizan devoluciones. El total debe completarse 10 días antes."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        requirements: [
            "No requiere conocimiento previo"
        ],
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: false,
        stock: false
    },
    {
        id: 2,
        title: "TALLER PARA EL MANEJO DEL DUELO, MIEDO Y DOLOR EMOCIONAL",
        description: "El dolor es inevitable, así como las pruebas de fe. Sin embargo, no resulta sencillo\n" +
            "afrontar cualquier tipo de pérdida, ruptura y mucho menos, duelo.\n" +
            "Por ello, caer en los refugios del miedo, así como perder el norte y los propósitos,\n" +
            "paralizan la vida.\n" +
            "Por ello, la escritora y coach emocional, Rosa Maria Cifuentes, brindará un taller\n" +
            "dedicado a todas las personas que desean renacer\n",
        themes: [
            "Dolor emocional y lesiones que marcan la vida: formas de asumirlo",
            "El duelo: Fases y formas de superarlo con guía adecuada",
            "Miedos paralizantes: fobia, trauma y ansiedad de escape. Estrategias para canalizarlo y afrontarlos",
            "Estrategias para renacer tras pérdidas, rupturas y dolor inmerecido",
            "Depresión y causas: Detecta lo que te ayudará a sanar",
            "Miedo y frustración: fases ypa formas de revertirlo",
        ],
        image: "/assets/images/talleres_1.jpg",
        date: {
            beginning: "2025-12-13T10:00:00",
            end: "2025-12-14T17:00:00"
        },
        hour: "10:00 am - 5:00 pm (break 1:00 pm)",
        mode: ["Presencial", "Zoom"],
        location: {
            name: "Cámara de Comercio de Lima",
            address: "Av Giusseppe Garibaldi 396, Jesús María"
        },
        cost: {
            pen: 600,
            usd: 200,
            money_advance: 300,
            notes: "No se realizan devoluciones. El total debe completarse 10 días antes."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: false,
        stock: false
    },
    {
        id: 3,
        title: "COACHING PARA VENCER DEPENDENCIAS EMOCIONALES, RELACIONES TÓXICAS Y ELEVAR EL AUTOESTIMA",
        description: "Sentirse en equilibrio y con la capacidad de tomar decisiones, salir de situaciones complicadas y establecer metas con constancia cada vez resulta más complicado por estos tiempos. Es necesario entrenar el pensamiento y desarrollar actitudes que permitan potenciar la personalidad hacia la madurez.\n\nPor ira, miedo, frustración, apegos o falta de equilibrio es más sencillo repetir errores y no hallar la salida para vivir satisfecho y en paz consigo mismo. Quienes no saben manejar sus emociones caen constantemente en relaciones afectivas dependientes, no saben tomar decisiones ante los retos de la vida, tienen problemas para socializar, se comunican sin éxito o tienen problemas para ser constantes porque viven postergando sus tareas diarias al sentir que la ansiedad de pensamiento los agobia.\n\nPor ello, el presente taller te ofrece aprender a conocer tus emociones, entrenar los pensamientos y vencer apegos emocionales para lograr sentirte en paz y desarrollar un autoestima saludable.",
        themes: [
            "Tipos de pensamiento y actitudes insanas que dañan la personalidad",
            "Pensamientos aprendidos, innatos",
            "Origen de las dependencias emocionales",
            "Pensamiento y ansiedad. Rol del entorno y medios de comunicación al respecto",
            "Técnicas para reordenar el pensar y vencer la angustia, ira y apatía",
            "Formas de vencer el pensamiento anticipatorio por inseguridad y baja autoestima",
            "Perfil emocional de los maltratadores, formas de comunicación, tips para reconocerlos y cómo afrontarlos",
            "Tipos de dependencias emocionales",
            "Dependencia afectiva (en las relaciones de pareja), causas y pensamiento obsesivo",
            "Dependencia a los malos entornos: rol de amistades, alienación, superficialidad",
            "Pensamiento ansioso por competencia y rol del ego en la toma de decisiones",
            "Causas de la frustración emocional: convicciones, ego y temperamento",
            "Las falsas recetas de la felicidad",
            "Causas del dolor y sufrimiento emocional y cómo aprender de él",
            "Obstinación como consecuencia de competitividad, baja autoestima y miedo al qué dirán",
            "Formas de asumir rupturas (sentimentales, interpersonales) y llevar el duelo",
            "Formas de vencer el mal recuerdo y combatir pensamientos de recaída por apego afectivo",
            "Plan de vida para recobrar el autoestima (profesional, de apariencia y sentimental)",
            "Formas seguras de superar crisis inesperadas mediante coaching ontológico y técnicas holísticas de sanación"
        ],
        image: "/assets/images/talleres_1.jpg",
        date: {
            beginning: "2025-09-13T10:00:00",
            end: "2025-09-14T17:00:00"
        },
        hour: "10:00 am - 5:00 pm",
        mode: ["Presencial"],
        location: {
            name: "Cámara de Comercio de Jesús María",
            address: "Av Giusseppe Garibaldi 396, Jesús María"
        },
        cost: {
            pen: 600,
            usd: 200,
            money_advance: 300,
            notes: "No se realizan devoluciones. Si no puedes asistir, puedes enviar a otra persona en tu lugar avisando con anticipación. El total debe completarse 10 días antes (13 de agosto)."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        requirements: [
            "No requiere conocimiento previo"
        ],
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: false,
        stock: false
    },
    {
        id: 4,
        title: "EMPRENDIMIENTOS Y NEGOCIOS PARA CRECER EL 2026 Y VENCER\n" +
            "KARMAS APLICANDO ASTROLOGÍA Y NUMEROLOGÍA",
        description: "Arrancar el año con energía y en especial, poder de decisión es vital para elevar la seguridad y serenidad. Por ello, nuestra coach emocional y astróloga de cabecera, ha preparado un taller presencial y zoom con el que compartirá con sus seguidores del mundo, todo lo que deben saber acerca de los tránsitos astrales 2026 y cómo aprovecharlos",
        themes: [
            "Efectos de Plutón en Acuario para los emprendimientos y negocios del 2026",
            "La vibración numerológica del año 2026 y los desafíos a nivel profesional y kármicos." +
            "Guía para destrabarlos.",
            "Impacto de Mercurio retrógrado 2026 en los emprendimientos e inversiones.",
            "Fechas ideales de mudanzas, aperturas de negocios y sociedades el 2026.",
            "Restaurar y construir el 2026/ ciclos de Júpiter apropiados y fases de la luna que lo rijan.",
            "Karma y pérdidas en negocios. Prevenir antes que lamentar el 2026.",
            "Ciclos de bonanza y de pérdidas que se repiten en tu carta natal."
        ],
        image: "/assets/images/talleres_4.heic",
        date: {
            beginning: "2025-11-29T10:00:00",
            end: "2025-11-30T17:00:00"
        },
        hour: "10:00 am - 5:00 pm (break 1:00 pm)",
        mode: ["Presencial", "Zoom"],
        location: {
            name: "Cámara de Comercio de Lima",
            address: "Av Giusseppe Garibaldi 396, Jesús María"
        },
        requirements: [
            "1. Tener tu hora natal exacta de nacimiento\n" +
            "2. Tener la Agenda Astral Zefiro 2026"
        ],
        cost: {
            pen: 700,
            usd: 200,
            money_advance: 350,
            notes: "No se realizan devoluciones. El total debe completarse 10 días antes."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: false,
        stock: false
    },
    {
        id: 5,
        title: "TALLER DE NUMEROLOGÍA Y ASTROLOGIA PARA ANÁLISIS DE SOCIEDADES, CREACIÓN DE EMPRESAS, SELECCIÓN DE PERSONAL Y COMPATIBILIDAD SENTIMENTAL",
        themes: [
            "Características y peculiaridades del decanato de nacimiento según los signos zodiacales y su influencia en la vida afectiva y en la elección de sociedades.",
            "Rasgos numerológicos de empresarios, personas con perfil independiente y personas con mayor capacidad para el trabajo subordinado",
            "El rol del año de nacimiento en la selección y conformación de equipos de trabajo.",
            "Ciclos astrológicos y numerológicos favorables para sembrar proyectos, crecer y asumir compromisos importantes.",
            "El rol de Venus en la carta natal y su conexión con la numerología.",
            "Planetas kármicos que intervienen en la creación de empresas, sociedades y vida sentimental",
            "Guía numerológica y astral para seleccionar personal eficiente.",
            "Análisis numerológico de pareja para evaluar matrimonios y elegir fechas de boda aplicando astrología.",
            "El impacto de la Luna en la elección de una sociedad o en el inicio de un vínculo afectivo",
            "Dia de nacimiento y rol profesional aplicando numerología y astrología"
        ],
        description: "La numerología y la astrología son disciplinas que, cuando se integran de manera consciente, permiten comprender mejor los ciclos de la vida, resolver inquietudes profundas y tomar decisiones más acertadas, especialmente en el ámbito financiero y en el de los vínculos personales y profesionales. Con este propósito, la especialista, astróloga, numeróloga y coach emocional Rosa María Cifuentes presenta en el año 2026 un nuevo taller diseñado para guiar a su amplia comunidad de seguidores y brindar herramientas prácticas que faciliten una vida más armónica y consciente",
        image: "/assets/images/talleres_5.jpg",
        date: {
            beginning: "2026-02-07T10:00:00",
            end: "2026-02-08T17:00:00"
        },
        hour: "10:00 am - 5:00 pm (break 1:00 pm)",
        mode: ["Presencial", "Zoom"],
        location: {
            name: "Cámara de Comercio de Lima",
            address: "Av Giusseppe Garibaldi 396, Jesús María"
        },
        cost: {
            pen: 700,
            usd: 200,
            money_advance: 350,
            notes: "No se realizan devoluciones. El total debe completarse 10 días antes."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: false,
        stock: false
    },
    {
        id: 6,
        title: "TALLER DE TAROT ANGELICO ZÉFIRO NIVEL II",
        themes: [
            "Este segundo nivel profundiza en la integración avanzada entre astrología, tarot, numerología y análisis simbólico, ampliando las herramientas interpretativas y la capacidad de respuesta del consultante profesional.",
            "El programa aborda el impacto de los tránsitos planetarios en la lectura del Tarot Astral Angélico Zéfiro, así como el uso de los tránsitos astrológicos para obtener respuestas rápidas y precisas dentro de la consulta.",
            "Se desarrollan técnicas especializadas de lectura aplicando numerología en la Baraja Astral Angélico Źéfiro, fortaleciendo la comprensión de los ciclos y patrones energéticos",
            "El diplomado incluye el estudio de la vivienda y de la personalidad de sus habitantes a través del Tarot Astral Angélico Zéfiro, así como un análisis profundo de los arcanos menores en relación con los tránsitos astrológicos, su aplicación en casos de salud y en situaciones de índole judicial.",
            "Los ciclos de vida y la interpretación de la compatibilidad en pareja y sociedades también será un aspecto a tratar con casos reales.",
            "Se realiza además un repaso integral del Tarot Astral Angélico Zéfiro Nivel I y Nivel II, con espacios dedicados a preguntas, consultas y supervisión de casos reales presentados por los participantes",
            "Como parte del enfoque avanzado del programa, se incorpora el estudio de criminalística simbólica e investigación de situaciones de caos, utilizando el Tarot Astral como herramienta de análisis, comprensión y orientación estratégica."
        ],
        description: "Continuando con el Diplomado de Tarot Astral Angélico Zéfiro, la especialista, astróloga y coach emocional Rosa María Cifuentes presenta el Diplomado de Tarot Astral Angélico Zéfiro Nivel II, dirigido exclusivamente a los alumnos que han completado satisfactoriamente el Nivel I.",
        image: "/assets/images/talleres_6.jpg",
        date: {
            beginning: "2026-01-31T10:00:00",
            end: "2026-02-01T17:00:00"
        },
        hour: "10:00 am - 5:00 pm (break 1:00 pm)",
        mode: ["Presencial", "Zoom"],
        location: {
            name: "Cámara de Comercio de Lima",
            address: "Av Giusseppe Garibaldi 396, Jesús María"
        },
        cost: {
            pen: 700,
            usd: 200,
            money_advance: 350,
            notes: "No se realizan devoluciones. El total debe completarse 10 días antes."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: false,
        stock: false
    },
    {
        id: 7,
        title: "Taller de Astrología profesional para Afrontar Tránsitos de Salud Física y Emocional",
        themes: [
            "La salud en la carta natal: Identificación de la zona de la salud en el mapa natal.",
            "Análisis de las casas astrológicas vinculadas al cuerpo físico, la energía vital y la salud emocional.",
            "Importancia del autocuidado según la configuración natal y hábitos que favorecen el equilibrio.",
            "Aspectos natales y predisposición a enfermedades",
            "Aspectos tensos de nacimiento que pueden indicar vulnerabilidades físicas o emocionales.",
            "Cómo leer estos indicadores sin fatalismo y desde una perspectiva",
            "Análisis de los tránsitos de Saturno, Plutón y Marte y su impacto en el cuerpo y la energía vital. Comprensión de los periodos de desgaste, inflamación, crisis, bloqueos o procesos de recuperación.",
            "Guía práctica para prevenir excesos y cuidar el organismo durante estos tránsitos.",
            "Neptuno y Urano en los procesos de salud: El rol de Neptuno en la salud emocional, psicosomática, inmunológica y en los procesos de confusión, evasión o agotamiento. Urano y su relación con crisis súbitas, sistema nervioso, estrés y cambios inesperados",
            "Mercurio y la salud mental: Importancia de Mercurio en los procesos cognitivos, emocionales y de comunicación interna. Impacto de Mercurio retrógrado en la ansiedad, el estrés, el insomnio y la toma de decisiones médicas.",
            "Guía para atravesar estos periodos con mayor claridad y orden mental.",
            "Astrología y decisiones médicas: Guía básica para seleccionar momentos favorables para cirugías, procedimientos médicos y tratamientos, considerando siempre el criterio médico profesional.",
            "Identificación de tránsitos que conviene evitar y aquellos que favorecen una mejor recuperación",
            "Reconocimiento de periodos propicios para tratamientos no invasivos, terapias alternativas, procesos de rehabilitación física y emocional, descanso y regeneración del cuerpo."
        ],
        description: "Este taller está dirigido a todas las personas interesadas en comprender cómo la astrología puede convertirse en una herramienta de autoconocimiento, prevención y acompañamiento en los procesos de salud física y emocional. Dictado por la reconocida astróloga y coach ontológico peruana, Rosa María Cifuentes. No es necesario contar con formación previa en astrología. Solo se requiere apertura, atención y disposición para observar los propios procesos personales desde una mirada consciente. La astrología, entendida como un lenguaje simbólico, permite identificar ciclos, ritmos y momentos de mayor vulnerabilidad o fortaleza, facilitando decisiones más conscientes respecto al cuidado del cuerpo, la mente y las emociones.",
        image: "/assets/images/talleres_7.png",
        date: {
            beginning: "2026-03-21T10:00:00",
            end: "2026-03-22T17:00:00"
        },
        hour: "10:00 am - 5:00 pm (break 1:00 pm)",
        mode: ["Presencial", "Zoom"],
        location: {
            name: "Cámara de Comercio de Lima",
            address: "Av Giusseppe Garibaldi 396, Jesús María"
        },
        cost: {
            pen: 800,
            usd: 250,
            money_advance: 400,
            notes: "No se realizan devoluciones. El total debe completarse 10 días antes."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: false,
        stock: false
    },
    {
        id: 8,
        title: "TALLER ¿PORQUÉ LA CASA TE ELIGE A TI?\n",
        themes: [
            "Las energías planetarias que intervienen en los procesos de mudanza.",
            "Las lecciones de vida asociadas a determinadas propiedades-",
            "Los factores emocionales que pueden influir en la elección de una vivienda.",
            "Los vínculos entre el hogar, la salud emocional y el bienestar físico.",
            "Los efectos que tienen los espacios y la decoración sobre nuestro equilibrio interior.",
            "Las señales astrológicas que alertan sobre etapas de cambio y transformación."
        ],
        description: "Muchas veces no comprendemos por qué, al elegir una vivienda, comienzan a suceder" +
            "una serie de acontecimientos inesperados. Algunas personas descubren que, tras" +
            "mudarse, aparecen problemas económicos, conflictos familiares recurrentes," +
            "dificultades emocionales o incluso alteraciones en la salud física y psicológica.\n \n" +
            "¿Es casualidad?\n \n" +
            "Tras el éxito de sus publicaciones La casa te elige a ti y La magia de tu casa, la" +
            "reconocida coach emocional y astróloga predictiva Rosa María Cifuentes presenta un " +
            "taller especializado que busca ayudar a comprender la profunda relación existente entre" +
            "la carta natal, los procesos de aprendizaje del alma y la elección de una propiedad.\n" +
            "A través de una metodología práctica y personalizada, cada participante podrá identificar" +
            "en su propia carta natal aquellos indicadores que revelan experiencias kármicas," +
            "desafíos emocionales y oportunidades de crecimiento vinculadas a mudanzas, compra" +
            "de inmuebles y cambios de residencia.\n\n"+"Este taller está dirigido exclusivamente a personas que cuentan con su hora exacta de" +
            "nacimiento, información que deberá ser obtenida de la partida de nacimiento para" +
            "realizar un análisis preciso.\n" +
            "Cada participante trabajará con su propia carta natal y recibirá herramientas de" +
            "autoconocimiento que le permitirán comprender mejor su historia personal, reflexionar" +
            "sobre los procesos que está viviendo y tomar decisiones más conscientes respecto a su" +
            "hogar y su futuro.\n" +
            "Se trata de una experiencia diseñada para quienes desean sanar vínculos emocionales," +
            "mejorar su calidad de vida, comprender el significado profundo de los cambios de" +
            "residencia y descubrir cómo determinados espacios pueden convertirse en aliados de su bienestar",
        image: "/assets/images/talleres_8.jpeg",
        date: {
            beginning: "2026-07-18T10:00:00",
            end: "2026-07-19T15:30:00"
        },
        hour: "10:00 am - 3:30 pm (break 1:00 pm)",
        mode: ["Presencial", "Zoom"],
        location: {
            name: "Sociedad Nacional de Industrias.",
            address: "Los Laureles 365, San Isidro."
        },
        cost: {
            pen: 650,
            usd: 205,
            money_advance: 325,
            notes: "No se realizan devoluciones. El total debe completarse 10 días antes."
        },
        contact: {
            whatsapp: "999202119",
            instructions: "Enviar ticket de transferencia indicando nombre de la persona que abonó."
        },
        organizer: "Rosa María Cifuentes (Astróloga y terapeuta profesional)",
        notes: "Los esperamos ❤️ CHISPITAS DE LUZ ✨️",
        is_new: true,
        stock: true
    },
];

export default coaches;
